// SHIPPOP-BANNER API via the SHIPPOP gateway (/v1/banner/* is routed to the banner service's /api/*).
// UAT builds set VUE_APP_BANNER_API=https://api.shippop.dev/v1/banner (.env.development, .env.staging);
// production and white-label builds don't set it and use the PROD gateway below.
export const BANNER_API = (process.env.VUE_APP_BANNER_API || "https://api.shippop.com/v1/banner").replace(/\/+$/, "");
